import React from 'react';
import { DownloadCard } from 'src/components/enterprise/features/Employee/EmployeeListPage/components/AddEmployeesDialog/DownloadCard';
import { useDownloadEmployeesCsv } from 'src/components/enterprise/features/Employee/EmployeeListPage/hooks/useDownloadEmployeesCsv';

export function DownloadEmployeesList(): JSX.Element {
  const { downloadEmployeesCsv, isDownloading } = useDownloadEmployeesCsv();

  const handleDownload = (): void => {
    downloadEmployeesCsv();
  };

  return (
    <DownloadCard
      title="Edit current employees"
      description="Download your latest list of employees, make any edits, and upload your new version."
      actionLabel="Download employee list"
      onClick={handleDownload}
      isLoading={isDownloading}
      isDisabled={isDownloading}
    />
  );
}
